module.exports = __webpack_public_path__ + "img/chevron-right.eb816c97.svg";